<template>
  <div
    class="toggle-container"
    :class="`color-${style.textColor} bg-${style.bgColor}`"
  >
    <em class="mr-2" :class="`fas fa-${style.icon} ${style.textColor}`" />
    <div dir="rtl">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestFilterToggle',
  props: {
    text: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style() {
      return {
        icon: this.isOpen ? 'chevron-down' : 'chevron-up',
        textColor: this.isOpen ? 'blue-light' : 'white',
        bgColor: this.isOpen ? 'dark-blue-1' : 'orange-light-2',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.toggle-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px 4px 0px 0px;
  transform: rotate(90deg);
  height: 29px;
  width: 156px;
  position: absolute;
  right: -93px;
  top: 173px;
  em {
    cursor: pointer;
    font-size: 12px;
  }
  div {
    cursor: pointer;
    transform: rotate(180deg);
    font-size: 14px;
  }
}
</style>
